import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnstyledImage from "./image";
import { Link } from "gatsby";
import { addAlpha } from "../utils/helpers";

const Wrapper = styled(Link)`
  aspect-ratio: 16/9;
  width: calc(100% / 2);
  height: auto;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  text-decoration: none;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }

  @media (hover: hover) {
    &:hover {
      & .textbox {
        min-width: 100%;
        min-height: 100%;
        text-decoration: underline;
        cursor: pointer;
      }
      & .img {
        transform: scale(1.1);
        cursor: pointer;
      }
      @media (prefers-reduced-motion) {
        & .img {
          transform: none;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 100%;
  }
`;

const Image = styled(UnstyledImage)`
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease-in-out !important;
  position: absolute;
  @media (prefers-reduced-motion) {
    transition: none;
  }
`;
const Textbox = styled.div.attrs(({ $opacity }) => ({
  $opacity: $opacity ? $opacity / 100 : 0.5,
}))`
  min-width: 0;
  min-height: 0;
  padding: 15px;
  font-size: 1.1rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontLinks.fontFamily};
  background-color: ${({ theme, $opacity }) =>
    addAlpha(theme.colors.accent1, $opacity)};
  transition: all 0.3s cubic-bezier(0.27, 0.12, 0.3, 0.99);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  @media (prefers-reduced-motion) {
    transition: none;
  }
`;

const CTACard = ({ linkUrl, image, imgSrc, imgAlt, label, opacity }) => {
  return (
    <Wrapper to={linkUrl}>
      <Image className="img" src={imgSrc} alt={imgAlt} image={image} />
      <Textbox className="textbox" $opacity={opacity}>
        {label}
      </Textbox>
    </Wrapper>
  );
};

CTACard.propTypes = {
  linkUrl: PropTypes.string.isRequired,
  imgSrc: PropTypes.object,
  image: PropTypes.object,
  imgAlt: PropTypes.string,
  label: PropTypes.string,
  opacity: PropTypes.number,
};

CTACard.defaultProps = {
  imgSrc: undefined,
  image: undefined,
  imgAlt: undefined,
  label: undefined,
};

export default CTACard;
